import { IPromoBeket } from 'shared/api/beket/main-page/model.ts'
import { clientApi } from 'shared/api/clientApi'
import { Response } from 'shared/models/general'

export const MainPageBeket = {
  getPromoList() {
    return clientApi.get<Response<IPromoBeket[]>>('ads/baners?page=BUS')
  },
}
